import { createSlice } from "@reduxjs/toolkit";

export const stepSlice = createSlice({
  name: "step",
  initialState: {
    currentStep: 1,
    step3Data: [],
    templateData: null,
  },
  reducers: {
    nextStep: (state) => {
      state.currentStep += 1;
    },
    prevStep: (state) => {
      if (state.currentStep > 0) state.currentStep -= 1;
    },
    setStep: (state, action) => {
      state.currentStep = action.payload;
    },

    // Save Step 3 data
    setStep3Data: (state, action) => {
      state.step3Data = action.payload;
    },

    // NEW: Save Template Data from Step 8
    saveTemplateData: (state, action) => {
      state.templateData = action.payload;
    },

    // Optional: Clear all step data if needed
    resetOnboarding: (state) => {
      state.currentStep = 0;
      state.step3Data = [];
      state.templateData = null;
    },
  },
});

export const {
  nextStep,
  prevStep,
  setStep,
  setStep3Data,
  saveTemplateData,
  resetOnboarding,
} = stepSlice.actions;

export default stepSlice.reducer;
